<template>
  <van-dialog v-model="visible" :show-cancel-button="false" :show-confirm-button="false">
      <div class="header">
        <van-icon name="cross" @click="onCancel" />
      </div>
      <div class="msg" v-html="option.message">
      </div>
      <div class="footer">
        <van-button v-if="option.cancelButtonText" class="cancel-button" @click="onCancel">
          {{option.cancelButtonText}}
        </van-button>
        <van-button class="confirm-button"  @click="onConfirm">
          {{option.confirmButtonText}}
        </van-button>
      </div>
  </van-dialog>
</template>

<script>
import Vue from 'vue';
import {
  Toast,
  Dialog,
  Icon,
  Button,
} from 'vant';
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Button);
export default {
  name: "Dialog",
  data(){
    return {
      visible:false,
      option:{
        message:'',
        confirmButtonText:'确认',
        cancelButtonText:'取消'
      }
    };
  },
  methods: {
    show(options)
    {
      console.log('options',options)
      let defaultOptions={
          message:'',
          confirmButtonText:'确认',
          cancelButtonText:'取消'
      };
      this.visible = true
      this.option={...defaultOptions,...options};
      console.log('this.option',this.option)
    },
    onCancel(){
      this.visible=false;
      this.callBack(false);
    },
    onConfirm(){
      this.visible=false;
      this.callBack(true);
    }
  }
}
</script>

<style scoped>
  .van-dialog{
    border-radius: 8px;
  }

 .van-dialog>>> .van-dialog__content{
   padding: 16px 20px;
 }

 .header{
    position: relative;
    height: 18px;
 }
 .header>>> .van-icon-cross{
   position: absolute;
   right: 0px;
   top:0px;
 }
 .msg{
   font-family: PingFangSC-Regular;
   font-size: 14px;
   color: #20253F !important;
   text-align: center;
   line-height: 18px;
   font-weight: 400;
 }
 .footer{
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 20px;
 }
 .cancel-button{
   width: 114px;
   /*flex: 1;*/
   height: 40px !important;
   background: #F5F7FA !important;
   border-radius: 4px;

   font-family: PingFangSC-Regular;
   font-size: 14px;
   color: #20253F;
   text-align: center;
   font-weight: 400;
 }
 .confirm-button{
   width: 114px;
   /*flex: 1;*/
   height: 40px !important;
   background: none;
   background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
   border-radius: 4px;

   font-family: PingFangSC-Regular;
   font-size: 14px;
   color: #FFFFFF;
   letter-spacing: 0;
   text-align: center;
   font-weight: 400;
 }
 .cancel-button+.confirm-button{
   margin-left: 12px;
 }
</style>